<template>
    <HomeLayout sidebarClasss="sidebar-garden-help" :url_base="url_base" :logo="logo"
        :sidebar_items="customer_sidebar_items" :logout_default_icon="logout_default_icon"
        :logout_active_icon="logout_active_icon" />
</template>
    
    
<script>
import $ from "jquery";
import HomeLayout from "@/components/HomeLayout/Index.vue";
import { getImgUrl } from "@/utils/helper-functions.js";
export default {
    name: "GardenHelpCustomerHome",
    components: { HomeLayout },
    data() {
        return {
            url_base: "garden_help",
            logo: this.getImgUrl("garden-help/Logo.png"),
            customer_sidebar_items: [
                {
                    title: "Find Contractors",
                    url: "find_contractors",
                    default_icon: this.getImgUrl("garden-help/community-icon.png"),
                    active_icon: this.getImgUrl("garden-help/community-icon-active.png"),
                }, {
                    title: "Jobs Table",
                    url: "jobs/jobs_table",
                    default_icon: this.getImgUrl("garden-help/jobs-icon.png"),
                    active_icon: this.getImgUrl("garden-help/jobs-icon-active.png"),
                },
                {
                    title: "Add New Job",
                    url: "jobs/add_job",
                    default_icon: this.getImgUrl("garden-help/add-job-icon.png"),
                    active_icon: this.getImgUrl("garden-help/add-job-icon-active.png"),
                },
            ],
            logout_default_icon: this.getImgUrl("garden-help/logout-icon.png"),
            logout_active_icon: this.getImgUrl("garden-help/logout-icon-active.png"),
        };
    },
    updated() { },
    mounted() { },

    methods: {
        getImgUrl,
        logout() { },
    },
};
</script>
<style scoped::v-deep >
@import "styles/garden-help-button-styles.css";
@import "styles/garden-help-styles.css";
</style>


// WEBPACK FOOTER //
// src/projects/garden_help/CustomerHome.vue